<script setup>
const emit = defineEmits(['close', 'continue']);

const $t = inject('$t');

const state = reactive({
  is_loading: false,
});

async function onContinue() {
  state.is_loading = true;
  emit('continue');
}
</script>

<template>
  <HawkModalContainer>
    <HawkModalHeader @close="emit('close')">
      <template #title>
        <div class="font-semibold text-lg">
          {{ $t('Reduce progress') }}
        </div>
      </template>
    </HawkModalHeader>
    <HawkModalContent>
      <div class="text-gray-700 text-sm">
        {{ $t('Entered value is less than current progress. Are you sure you want to continue?') }}
      </div>
    </HawkModalContent>
    <HawkModalFooter>
      <template #right>
        <div class="flex justify-end w-full col-span-full">
          <div>
            <HawkButton
              class="mr-3"
              type="outlined"
              @click="emit('close')"
            >
              {{ $t('Cancel') }}
            </HawkButton>
            <HawkButton
              :is-loading="state.is_loading"
              @click="onContinue"
            >
              {{ $t('Continue') }}
            </HawkButton>
          </div>
        </div>
      </template>
    </HawkModalFooter>
  </HawkModalContainer>
</template>
